import { NgModule } from "@angular/core";
import { ACLDirective } from "./acl.directive";
import { CallToDirective } from './call-to.directive';
import { MailToDirective } from "./mail-to.directive";
import { WhatappsToDirective } from "./whatapps-to.directive";

@NgModule({
  imports: [],
  declarations: [
    ACLDirective,
    CallToDirective,
    MailToDirective,
    WhatappsToDirective
  ],
  exports: [
    ACLDirective,
    CallToDirective,
    MailToDirective,
    WhatappsToDirective
  ],
})
export class CustomDirectiveModule {}
